import { render, staticRenderFns } from "./redTourism.vue?vue&type=template&id=57b6f1f2&scoped=true&"
import script from "./redTourism.vue?vue&type=script&lang=js&"
export * from "./redTourism.vue?vue&type=script&lang=js&"
import style0 from "./redTourism.vue?vue&type=style&index=0&id=57b6f1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6f1f2",
  null
  
)

export default component.exports